import * as React from 'react';
import { isPropValid, styled, ThemeConsumer } from '../../styled-components';
const Container = styled.span.withConfig({
  shouldForwardProp: isPropValid
})`
  display: inline-block;
  height: ${({
  size
}) => size};
  width: ${({
  size
}) => size};
`;
export const SVG_DEFAULT_SIZE = '100%';
export const IconBase = ({
  variants,
  className,
  size = '1em'
}) => /*#__PURE__*/React.createElement(ThemeConsumer, null, theme => /*#__PURE__*/React.createElement(Container, {
  size: size
}, theme !== null && theme !== void 0 && theme.themeId && variants[theme === null || theme === void 0 ? void 0 : theme.themeId] ? variants[theme.themeId](className, size) : variants.mgb(className, size)));